module.exports = __webpack_public_path__ + "static/img/urgentnotice.56d9936.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/urgentnotice.jpg
// module id = Wxm0
// module chunks = 0